import React, { useState } from 'react';
import { createSlug } from '../../util/urlHelpers';
import { FormattedMessage } from '../../util/reactIntl';
import { NamedLink, IconCollection } from '..';
import ResponsiveImage from '../ResponsiveImage/ResponsiveImage';
import css from './AlogoliaSearchCard.module.css';
import { formatMoney } from '../../util/currency';
import { types } from '../../util/sdkLoader';

const { Money } = types

const AlogoliaSearchCard = props => {

  const [handleBagItemInProgress, setHandleBagItemInProgress] = useState(false);

  const { hit, currentUser, onUpdateProfile, handleLikeItems, history, intl } = props;

  const { title, listingImagesUrl = [], heroImageId, price, size, objectID, authorId, markForSale, originalPrice } = hit || {};

  const heroImage = (heroImageId && listingImagesUrl.map(listImg => listImg.public_id).includes(heroImageId))
  ? listingImagesUrl.find(listImg => listImg.public_id === heroImageId)
  : listingImagesUrl[0] || {};

  const { bagItems = [], likeItems = [] } =
    (!!currentUser?.id && currentUser.attributes.profile.protectedData) || {};

  const index = bagItems && bagItems.findIndex(e => e == objectID);
  const likeIndex = likeItems && likeItems.findIndex(e => e == objectID);
  const isOwnListing = !!currentUser?.id && authorId === currentUser?.id?.uuid;

  const handleBagItems = () => {
    if (isOwnListing) {
      return null;
    }
    if (!currentUser?.id) {
      history.push('/login');
    } else {
      if (index > -1) {
        bagItems.splice(index, 1);
        setHandleBagItemInProgress(true);
      } else {
        bagItems.push(objectID);
        setHandleBagItemInProgress(true);
      }
      const profile = {
        protectedData: {
          bagItems,
        },
      };
      onUpdateProfile(profile);
    }
  };
  const formatPrice = (price && price.amount) ? new Money(price?.amount, price?.currency) : null;
  const formatOriginalPrice = originalPrice ? new Money(originalPrice * 100, price?.currency) : null;
  return (
    <div className={css.root}>
      <NamedLink
        name="ListingPage"
        params={{ id: objectID, slug: createSlug(title) }}
        className={css.link}
        isSearchPage={false}
        target="_blank"
      >
        <div>
          {!!heroImage ? (
            <div className={css.imageWrapper}>
              {isOwnListing ? <p className={css.onproduct}>Own Product</p> : null}
              {/* <img src={listingImagesUrl[0]?.url} alt="listing-img" /> */}
              <ResponsiveImage
                renderCloudinaryImage={{
                  secure_url: heroImage.url,
                  alt: `Listing Card`,
                  variantsToRender: [
                    'listing-card-6x',
                    'listing-card-4x',
                    'listing-card-2x',
                    'listing-card',
                  ],
                  defaultVariant: 'listing-card-6x',
                }}
              />
            </div>
          ) : (
            <div className={css.imageWrapper}>
              <IconCollection icon={'NoImage'} />{' '}
            </div>
          )}
          <p className={css.title}>{title}</p>
        </div>
      </NamedLink>

      <div className={css.emptySpace}></div>
      <div className={css.cardFooter}>
        <div className={css.priceWrapper}>
          <div className={css.priceContent}>
            {(price && price.amount) ? <span className={css.price}>{formatMoney(intl, formatPrice)}&nbsp;</span> : null}
            {formatOriginalPrice ? <span className={css.originalPrice}>{formatMoney(intl, formatOriginalPrice)}</span> : null}
          </div>
          {(size || size == 0) && (
            <span>
              <FormattedMessage id="ListingCard.size" values={{ size: size?.label ?? size }} />
            </span>
          )}
        </div>
        {(!isOwnListing && markForSale) && (
          <div className={css.bagButton}>
            {handleBagItemInProgress ? (
              <span>
                <div className={css.loader}></div>
                Loading
              </span>
            ) : index > -1 ? (
              <span
                onClick={e => {
                  e.preventDefault();
                  e.stopPropagation();
                  handleBagItems();
                }}
              >
                <IconCollection icon={'IconBagAdded'} />
                <span className={css.desktopText}>
                  <FormattedMessage id="ListingCard.addedToBag" />
                </span>
              </span>
            ) : (
              <span
                onClick={e => {
                  e.preventDefault();
                  e.stopPropagation();
                  handleBagItems();
                }}
              >
                <IconCollection icon={'addToBag'} />
                <span className={css.desktopText}>
                  <FormattedMessage id="ListingCard.addToBag" />
                </span>
              </span>
            )}
          </div>
        )}
      </div>
      {!isOwnListing && (
        <div
          onClick={e => {
            e.preventDefault();
            likeIndex > -1 ? handleLikeItems(objectID, isOwnListing) : handleLikeItems(objectID, isOwnListing);
          }}
          className={css.likeIcon}
        >
          {likeIndex > -1 ? (
            <span>
              <IconCollection icon="dislikeIcon" />
            </span>
          ) : (
            <span>
              <IconCollection icon="likeIcon" />
            </span>
          )}
        </div>
      )}
    </div>
  );
};

export default AlogoliaSearchCard;
